import { HttpErrorResponse } from '@angular/common/http';

export function getErrorText(error: HttpErrorResponse, defaultText: string = null): string {
  const rawError = error?.error;

  if (!rawError) return defaultText;

  if (typeof rawError === 'string') return rawError;

  // ODataError
  if ('value' in rawError && typeof rawError.value === 'string') {
    return rawError.value;
  }

  // ODataErrorExtended
  if ('error' in rawError && typeof rawError.error?.message === 'string') {
    return rawError.error.message;
  }

  return defaultText;
}
